import { useBlockProps, RichText } from '@wordpress/block-editor';
import InfoBoxWrapper from '../html/src/info-box/InfoBoxWrapper';

export default function save( { attributes } ) {
	const { text, blockId } = attributes;
	const blockProps = useBlockProps.save( {
		className: `alpha-info-box-blocks alpha-info-box-block-${ blockId }`,
	} );

	return (
		<div { ...blockProps }>
			<InfoBoxWrapper attributes={ attributes } />
		</div>
	);
}
